import { createORPCClient } from "@orpc/client";
import { RPCLink } from "@orpc/client/fetch";
import type { RouterClient } from "@orpc/server";
import { createTanstackQueryUtils } from "@orpc/tanstack-query";
import type { AppRouter } from "@bibacv/api-contracts";
import { env } from "@/lib/env";
import { getAuthToken, clearAuthToken } from "@/lib/auth-token";

const link = new RPCLink({
  url: `${env.FRONTEND__API_URL}/rpc`,
  headers: async () => {
    const token = await getAuthToken();
    return token ? { authorization: `Bearer ${token}` } : {};
  },
  fetch: async (request, init) => {
    const retry = request.clone();
    const res = await fetch(request, init);
    if (res.status !== 401) return res;
    clearAuthToken();
    const token = await getAuthToken();
    if (!token) return res;
    retry.headers.set("authorization", `Bearer ${token}`);
    return fetch(retry, init);
  },
});

export const orpcClient: RouterClient<AppRouter> = createORPCClient(link);

export const orpc = createTanstackQueryUtils(orpcClient);
